// ============================================================================
// THEME CONFIGURATION — VoltaGex
// Old Java Temple Era — Sacred Andesite Stone & Ceremonial Gold
// ============================================================================

const theme = {
  "id": "voltagex",
  "siteId": "voltagex",
  "orderPrefix": "VGX",
  "brand": {
    "name": "VoltaGex",
    "short": "VGX",
    "legalName": "PT VOLTA GEX NUSANTARA"
  },
  "meta": {
    "title": "VoltaGex | Gerbang Digital Warisan Nusantara",
    "description": "VoltaGex — candi digital tempat energi bertemu warisan. Top-up game dan voucher digital dengan kecepatan petir, dipandu cahaya emas kerajaan Mataram Kuno.",
    "themeColor": "#C9A227"
  },
  "assets": {
    "heroBg": "/hero-voltagex.jpg",
    "logo": "/logo-voltagex.svg"
  },
  "copy": {
    "hero": {
      "titleLine1": "Gerbang Energi",
      "titleLine2": "Nusantara Digital",
      "subtitle": "Seperti candi warisan leluhur yang berdiri kokoh, VoltaGex adalah nexus digital tempat kekuatan bertemu teknologi. Top-up game dan voucher digital — kecepatan cahaya emas kerajaan Mataram Kuno.",
      "searchPlaceholder": "Temukan produk di gerbang digital..."
    },
    "features": [
      {
        "label": "Kilat Dewata",
        "desc": "Transmisi instan bak petir Dewa Indra"
      },
      {
        "label": "Harga Candi",
        "desc": "Nilai terbaik dari puncak stupa"
      },
      {
        "label": "Perlindungan Kala",
        "desc": "Keamanan berlapis berkat wajah Kala"
      },
      {
        "label": "Penjaga 24 Jam",
        "desc": "Support sepanjang waktu dari para Dewa"
      }
    ],
    "cta": {
      "titlePrefix": "Bergabunglah sebagai ",
      "titleHighlight": "Brahmana",
      "titleSuffix": " Digital",
      "subtitle": "Jadilah bagian dari aliansi reseller VoltaGex. Dapatkan akses ke harga tertinggi kerajaan, panel kontrol sakral real-time, dan komunikasi langsung dengan penjaga candi.",
      "button": "Masuki Candi"
    },
    "footer": {
      "tagline": "VoltaGex — gerbang digital yang diilhami warisan candi Nusantara. Kecepatan kilat dewata, keandalan batu andesit, harga emas kerajaan Mataram Kuno."
    }
  },
  "colors": {
    "primary": "#C9A227",
    "secondary": "#A84D1A",
    "accent": "#4A7C59",
    "background": "#0D0906",
    "card": "#181210",
    "border": "#2C1F14",
    "foreground": "#F2E5C8",
    "success": "#4A7C59",
    "destructive": "#C0392B",
    "gradientFrom": "#C9A227",
    "gradientTo": "#8B3A1E"
  },
  "fonts": {
    "display": "'Cinzel Decorative', 'Cinzel', Georgia, serif",
    "body": "'Lora', Georgia, serif",
    "mono": "'Space Mono', monospace",
    "googleFontsUrl": "https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&family=Cinzel:wght@400;600;700&family=Lora:wght@400;500;600&family=Space+Mono:wght@400;700&display=swap"
  },
  "style": {
    "heroVisual": "volta-mandala",
    "mascotGlow": "drop-shadow(0 0 20px rgba(201, 162, 39, 0.5)) drop-shadow(0 0 40px rgba(168, 77, 26, 0.25))",
    "heroAccent1": "bg-primary/15",
    "heroAccent2": "bg-secondary/10"
  }
};

module.exports = theme;
